// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:31:36

export default {
  "id": "football-heads-2025",
  "slug": "football-heads-2025",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8d6f5a0f38c94c6b8a013ac330e85c3c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8d6f5a0f38c94c6b8a013ac330e85c3c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Football Heads 2025",
      "description": "Unlock your potential and prove your skills. Outplay your opponents using powerful kicks and unique power-ups. Finally let them know who is the boss with the emotes system - become a football legend today!\n",
      "instructions": "Use the arrow buttons to move and jump across the field. Perform various kicks with the ball buttons. Score more goals in the given time and win the match. Climb divisions and unlock all rewards. Random match powerups and player emotes are available.\n",
      "genres": [
        "Football"
      ],
      "tags": [
        "ball",
        "head",
        "headsoccer"
      ]
    },
    "zh-CN": {
      "title": "足球头部 2025",
      "description": "解锁你的潜能，证明你的技艺。利用强大的踢球技巧和独特的增益道具，超越对手。最后，通过表情系统让他们知道谁是老大——今天成为足球传奇吧！",
      "instructions": "使用箭头按钮移动和跳跃穿越场地。通过球按钮执行各种踢球动作。在规定时间内进更多球，赢得比赛。攀升联赛等级并解锁所有奖励。随机匹配加成和玩家表情包可用。",
      "genres": [
        "足球"
      ],
      "tags": [
        "球",
        "头",
        "头部足球"
      ]
    },
    "zh-TW": {
      "title": "足球頭 2025",
      "description": "解鎖你的潛力，證明你的技巧。使用強大的踢球和獨特的強化道具，超越對手。最後，透過表情系統讓他們知道誰是老大——今天成為足球傳奇吧！",
      "instructions": "使用方向鍵移動和跳躍穿越球場。使用球鍵進行各種踢球動作。在指定時間內射進更多球，贏得比賽。晉級分級並解鎖所有獎勵。隨機匹配加成與玩家表情圖示皆可使用。",
      "genres": [
        "足球"
      ],
      "tags": [
        "球",
        "頭",
        "頭 soccer"
      ]
    },
    "zh-HK": {
      "title": "足球頭2025",
      "description": "開啟你的潛能，展現你的技能。用強大的踢球技巧和獨特的增強道具超越對手。最後，透過表情系統告訴他們誰才是老大——成為足球傳奇今日開始！",
      "instructions": "使用方向按鈕移動及跳躍橫越場地。用球按鈕施展各種踢法。在限定時間內射入更多進球，獲勝比賽。晉升分組並解鎖所有獎勵。隨機比賽強化效果及球員表情圖片供選用。",
      "genres": [
        "足球"
      ],
      "tags": [
        "波",
        "頭",
        "頭足球"
      ]
    },
    "ja": {
      "title": "フットボール・ヘッズ2025",
      "description": "あなたの可能性を解き放ち、あなたのスキルを証明せよ。強力な蹴り技とユニークなパワーアップを使って、相手を圧倒せよ。ついにエモートシステムで誰がボスであることを彼らに示して－今日ここでサッカーの伝説に変身せよ！",
      "instructions": "矢印ボタンを使って移動し、ジャンプしてフィールドを渡り歩け。ボールボタンで様々な蹴り技を見せて。指定された時間内に多くのゴールを決め、試合に勝ちろ。リーグを昇格し、全ての報酬を解禁。ランダムなマッチパワーアップとプレイヤーエモートが利用可能。",
      "genres": [
        "フットボール"
      ],
      "tags": [
        "ボール",
        "ヘッド",
        "ヘッドソッカー"
      ]
    },
    "ko": {
      "title": "축구헤드 2025",
      "description": "자신의 잠재력을 깨우치고 기술을 입증해보세요. 강력한 발기와 독특한 파워업을 사용하여 상대를 제압하세요. 마침내 이모티콘 시스템을 통해 누가 보스인지 보여주세요 - 오늘 바로 축구 전설이 되세요!",
      "instructions": "아이콘을 사용하여 이동하고 점프하며 경장을 넘나드세요. 공 버튼으로 다양한 차단을 시행하세요. 주어진 시간 동안 더 많은 골을 넣어 경기를 이기세요. 등급을 올려 모든 보상을 해금하세요. 무작위 매치 파워업과 플레이어 이모티콘을 사용하세요.",
      "genres": [
        "축구"
      ],
      "tags": [
        "볼",
        "머리",
        "헤드스코어"
      ]
    },
    "fr": {
      "title": "Têtes de Foot 2025",
      "description": "Déverrouillez votre potentiel et prouvez vos compétences. Débarrassez-vous de vos adversaires grâce à des coups de pied puissants et des power-ups uniques. Enfin, montrez-leur qui est le patron avec le système d'émotes - devenez une légende du football dès aujourd'hui !",
      "instructions": "Utilisez les boutons flèches pour vous déplacer et sauter sur le terrain. Effectuez divers coups de pied avec les boutons de balle. Marquez plus de buts dans le temps imparti et gagnez le match. Montez dans les divisions et débloquez toutes les récompenses. Des améliorations de match aléatoires et des émotions de joueurs sont disponibles.",
      "genres": [
        "Football (le football)"
      ],
      "tags": [
        "balle",
        "tête",
        "headsoccer"
      ]
    }
  }
};
